import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

export const ClearedLink = ({ children, ...rest }) => {
  return (
    <div className="cleared-link-component">
      <NavLink {...rest}>{children}</NavLink>
    </div>
  );
};

ClearedLink.propTypes = {
  to: PropTypes.string,
};

export const ButtonLink = ({ children, ...rest }) => {
  return (
    <div className="button-link-component">
      <NavLink {...rest}>{children}</NavLink>
    </div>
  );
};

ButtonLink.propTypes = {
  to: PropTypes.string,
};

export const ClearedExternalLink = ({ children, ...rest }) => {
  return (
    <div className="cleared-link-component">
      <a {...rest}>{children}</a>
    </div>
  );
};
export { default as ControlsAction } from './ControlsActions/ControlsActions';
export { default as CollapseIcon } from './CollapseIcon/CollapseIcon';
export { default as IconButton } from './IconButton/IconButton';
export { default as IconDropdown } from './IconDropdown/IconDropdown';
